import { clsx } from 'clsx';
import { FC, ReactNode } from 'react';

import { Image } from '@repo/ui/Image';

import { ProgressBar } from '../ProgressBar/ProgressBar';
import styles from './FormHeader.module.scss';

type FormHeaderProps = {
  className?: string;
  onClickCarmaLogo: () => void;
  centerComponent?: ReactNode;
  rightComponent?: ReactNode;
  inbetweenComponent?: ReactNode;
  /** Progress of the checkout, should be a value between 0 and 1 */
  progressStep: number;
};

export const FormHeader: FC<FormHeaderProps> = ({
  className,
  progressStep,
  centerComponent,
  onClickCarmaLogo,
  rightComponent,
  inbetweenComponent,
}) => (
  <>
    <div className={clsx(styles.root, className)}>
      <div className={styles.topHeader}>
        <button type="button" className={styles.carmaLogo} onClick={onClickCarmaLogo} data-testid="carma-logo">
          <Image src="/images/carma-logo-wordmark.svg" alt="Carma" width={110} height={36} priority />
        </button>
        <div className={styles.mainContainer}>{centerComponent}</div>
        <div className={styles.rightContainer}>{rightComponent}</div>
      </div>
      {inbetweenComponent}
      <div className={styles.progressWrapper}>
        <ProgressBar progress={progressStep} label="Checkout progress" />
      </div>
    </div>
  </>
);
